import { Region } from "./region";
export class MasterRegionTemplate {
  id?: string;
  name?: string;
  values?:Region[];
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/masterRegionTemplate.ts